"use client";

import { useComebackUrl } from "@/components/hooks/use-comeback-url";
import { useLogoutWithCleanup } from "@/components/hooks/use-logout-with-cleanup";
import { useToast } from "@/components/ui/use-toast";
import { useRouter } from "next/navigation";
import { type FC, useEffect } from "react";

/**
 * comebackUrl, errorMessage付きの主に未認証時用のリダイレクト用コンポーネント
 *
 * オプションのパラメータが必要無い場合はこのコンポーネントを使う意味はなく、
 * クライアントリダイレクトよりサーバーリダイレクトの方が望ましいのでサーバーでnext/navigationのredirect関数などを使うこと
 */
export const UnauthorizedRedirect: FC<{
  redirectUrl: string;
  errorMessage?: string;
  comebackUrl?: string;
  // memo: trueの時、ログアウトしてからリダイレクトする、ログアウト状態でログアウトしても問題無い
  shouldLogout?: boolean;
}> = ({ comebackUrl, errorMessage, redirectUrl, shouldLogout = true }) => {
  const router = useRouter();
  const { toast } = useToast();
  const { setComebackUrl } = useComebackUrl();
  const { logout } = useLogoutWithCleanup();

  useEffect(() => {
    const run = async () => {
      if (shouldLogout) {
        await logout();
      }
      if (comebackUrl) {
        setComebackUrl(comebackUrl);
      }
      router.push(redirectUrl);
      if (errorMessage) {
        // 遷移でトーストが消えないようにするための苦肉の策
        setTimeout(() => {
          toast({
            title: errorMessage,
            variant: "error",
          });
        }, 0);
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
